import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

const EditCityTaxPage = () => {
    const { id: businessId, cityId: cityTaxId } = useParams(); // ✅ Extract both businessId and cityTaxId correctly
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCityTaxData = async () => {
            try {
                const response = await api.get(`/tax-info/edit-city/${businessId}/${cityTaxId}`);
                setFormData(response.data || {});
            } catch (err) {
                console.error("Error fetching city tax information:", err);
                setError("Failed to fetch city tax information.");
            } finally {
                setLoading(false);
            }
        };

        fetchCityTaxData();
    }, [businessId, cityTaxId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.put(`/tax-info/edit-city/${businessId}/${cityTaxId}`, formData);
            console.log("City tax information updated successfully!");
            navigate(-1);
        } catch (err) {
            console.error("Error updating city tax information:", err);
            alert("Failed to update city tax information.");
        }
    };

    if (loading) return <p>Loading city tax information...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="fed-tax-edit-page">
            <h4>Edit City Tax Information</h4>
            <form onSubmit={handleSubmit}>
               
                <label>
                    Account Number:
                    <input type="text" name="account_number" value={formData.account_number || ""} onChange={handleChange} />
                </label>
                <label>
                    Deposit Frequency:
                    <select name="deposit_frequency" value={formData.deposit_frequency || ""} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                    </select>
                </label>
                <button type="submit">Save Changes</button>
            </form>
        </div>
    );
};

export default EditCityTaxPage;
